import React from "react";
import { Box, Typography, Stack, TextField } from "@mui/material";
import dayjs from "dayjs";
import { DateTimePicker } from "@mui/x-date-pickers";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";

interface AnchorConfigurationProps {
    startDate: string;
    startTime: string;
    setStartDate: (val: string) => void;
    setStartTime: (val: string) => void;
    minDate: Date;
    primaryColor: string;
    primaryLightColor: string;
    secondaryColor: string;
    borderColor: string;
    stepDotStyle: (isActive: boolean) => React.CSSProperties;
    getTranslation: (key: string) => string;
}

const AnchorConfiguration: React.FC<AnchorConfigurationProps> = ({
    startDate,
    startTime,
    setStartDate,
    setStartTime,
    minDate,
    primaryColor,
    primaryLightColor,
    secondaryColor,
    borderColor,
    stepDotStyle,
    getTranslation,
}) => {
    return (
        <Box
            className="timer-panel-fade-in"
            sx={{
                position: "relative",
                borderLeft: `2px solid ${borderColor}`,
                pl: 4,
                pb: 2,
            }}
        >
            <Box sx={stepDotStyle(false)} />
            <Typography
                variant="caption"
                fontWeight={700}
                color={secondaryColor}
                sx={{ letterSpacing: 1, mb: 1.5, display: "block" }}
            >
                {getTranslation("timer.starts_at")}
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-start", pl: 2, pt: 2 }}>
                <DateTimePicker
                    label={getTranslation("pm.propertyeditor.specificproperties.label.select_date")}
                    viewRenderers={{
                        hours: renderTimeViewClock,
                        minutes: renderTimeViewClock,
                        seconds: renderTimeViewClock,
                    }}
                    slotProps={{
                        textField: {
                            size: "small",
                            sx: {
                                "& .MuiOutlinedInput-root": {
                                    backgroundColor: "background.paper",
                                },
                            },
                        },
                    }}
                    minDate={dayjs(minDate) as any}
                    value={dayjs(`${startDate}T${startTime}`) as any}
                    onChange={(value: any) => {
                        if (value && !isNaN(new Date(value).getTime())) {
                            const d = dayjs(value);
                            setStartDate(d.format("YYYY-MM-DD"));
                            setStartTime(d.format("HH:mm"));
                        }
                    }}
                />
            </Box>
        </Box>
    );
};

export default AnchorConfiguration;
